import HttpCliente from "../HttpCliente";

export const getTipoDocumentos = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/TipoDocumento/ObtenerTipos", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const postTipoDocumentos = (token, data) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/TipoDocumento/Crear", data, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const putTipoDocumentos = (token, data) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/TipoDocumento/EditarTipoDocumento", data, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });  
  });
}

export const deleteTipoDocumentos = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete(`/TipoDocumento/Deshabilitar/${id}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
}

export const getTipoDocumentoHabilitado = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/TipoDocumento/ObtenerTiposHabilitados", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
}